<template>
	<div
		class="collapsible"
		:class="{
			'collapsible--collapsed': !opened
		}"
	>
		<div
			class="collapsible__trigger"
			ref="trigger"
			@click="toggle"
		>
			<slot name="trigger"></slot>
		</div>
		<div
			class="collapsible__content"
			ref="content"
		>
			<slot></slot>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		initialOpen: {
			type: Boolean,
			default: true,
		}
	},
	data() {
		return {
			opened: this.initialOpen,
		};
	},
	methods: {
		toggle() {
			if (this.$refs.content.scrollHeight) {
				this.$refs.content.addEventListener('transitionend', e => {
					this.$refs.content.style.maxHeight = '';
				}, { once: true });

				this.$refs.content.style.maxHeight = `${this.$refs.content.scrollHeight}px`;
			}
			setTimeout(() => {
				this.opened = !this.opened;
				this.$emit('toggle', this.opened);
			}, 1);
    },
    open() {
      if (!this.opened) {
        this.toggle();
      }
    },
    close() {
      if (this.opened) {
        this.toggle();
      }
    },
	}
}
</script>
